import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';

// Material UI
import { withStyles } from '@material-ui/core';
import { getGlobalClasses } from '../../../themes';
import Paper from '@material-ui/core/Paper';
import AuthUserContainer from '../../../containers/AuthUser';
//import PtoRequestContainer from '../../../containers/PtoRequest';
import RequiredPtoRequestContainer from '../../../containers/RequiredPtoRequest';
import PropTypes from 'prop-types';
import EnhancedTable from '../../../components/table/EnhancedTable';
import FilterHeader from '../../../components/table/FilterHeader';
import { renderStatus, ptoTypeToDisplay } from '../util';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
	};
};

class RequiredPtoDashboard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'asc',
			orderBy: 'displayName',
			filter: '',
			filterTimeClockLocationId: '',
			refreshId: 0,
			isCancelDialogOpen: false,
			ptoRequestIdToCancel: undefined,
		};
	}

	//openCancelDialog

	handleOpenCancelDialog = (ptoRequestIdToCancel) => {
		this.setState({
			isCancelDialogOpen: true,
			ptoRequestIdToCancel,
		});
	};
	handleCloseCancelDialog = () => {
		this.setState({
			isCancelDialogOpen: false,
			ptoRequestIdToCancel: undefined,
		});
	};

	componentDidMount() {
		const { allRequiredPtoRequests, searchRequiredPtoRequests } = this.props;
		if (!allRequiredPtoRequests) {
			searchRequiredPtoRequests({
				params: {
					searchFor: 'allRequests',
				},
			});
		} else {
			this.formatPtoRequests();
		}
	}

	componentDidUpdate(prevProps) {
		const { allRequiredPtoRequests } = this.props;
		if (prevProps.allRequiredPtoRequests !== allRequiredPtoRequests) {
			this.formatPtoRequests();
		}
	}

	formatPtoRequests = () => {
		const { allRequiredPtoRequests, userMap } = this.props;
		const formattedPtoRequests = [];
		const pendingPtoRequests = [];
		const completedPtoRequests = [];
		allRequiredPtoRequests.forEach((ptoRequest) => {
			const {
				requiredPtoRequestId,
				dateAndHours,
				paidType,
				requestedForUserId,
				dateCreated,
				status,
			} = ptoRequest;

			const totalHours = _.sumBy(dateAndHours, 'hours');
			const totalDays = dateAndHours.length;
			const sortedDateAndHours = _.orderBy(dateAndHours, 'date', 'asc');

			const format = 'ddd M/D/YY';
			const firstDay = moment((_.first(sortedDateAndHours) || {}).date);

			let rangeDisplay = `${firstDay.format(format)}`;
			const rangeSort = firstDay.format('YYYY-MM-DD');
			if (totalDays >= 2) {
				const lastDay = moment((_.last(sortedDateAndHours) || {}).date);
				rangeDisplay = rangeDisplay + ` - ${lastDay.format(format)}`;
			}

			let isPending = false;
			if (status === 'pending') {
				isPending = true;
			}

			const requestor = userMap[requestedForUserId] || { firstName: 'missing' };
			const row = {
				requiredPtoRequestId,
				requestorDisplay: `${requestor.firstName} ${requestor.lastName}`,
				key: requiredPtoRequestId,
				rangeDisplay,
				rangeSort,
				dateCreated,
				dateCreatedFormatted: moment(dateCreated).format('M/D/YY h:mm a'),
				typeDisplay: ptoTypeToDisplay(paidType),
				totalDaysSort: totalDays,
				totalDaysDisplay: `${totalDays} days`,
				totalHoursSort: totalHours,
				totalHoursDisplay: `${totalHours} hours`,
				status: renderStatus(status),
				note: '',
			};

			if (isPending) {
				pendingPtoRequests.push(row);
			} else {
				completedPtoRequests.push(row);
			}
		});
		this.setState({ formattedPtoRequests, pendingPtoRequests, completedPtoRequests });
	};

	render() {
		const { classes } = this.props;

		const { formattedPtoRequests, pendingPtoRequests, completedPtoRequests } = this.state;

		if (!formattedPtoRequests) {
			return <div>Loading the PTO requests</div>;
		}

		const columns = [
			{ label: 'Employee', sortId: 'requestorDisplay', displayId: 'requestorDisplay' },
			{ label: 'Scheduled Date', sortId: 'rangeSort', displayId: 'rangeDisplay' },
			{ label: 'Type', sortId: 'typeDisplay', displayId: 'typeDisplay' },
			{ label: 'Days', sortId: 'totalDaysSort', displayId: 'totalDaysDisplay' },
			{
				label: 'Total Hours',
				sortId: 'totalHoursSort',
				displayId: 'totalHoursDisplay',
			},
			{ label: 'Status', sortId: 'status', displayId: 'status' },
			{
				label: 'Updated Schedule On',
				sortId: 'dateCreated',
				isNotSortable: true,
				displayId: 'dateCreatedFormatted',
			},
		];

		return (
			<Fragment>
				<FilterHeader label={'Pending Employee PTO Request'} canMakeUpdates={true} />
				<Paper className={classes.globalMainPaper}>
					{_.isEmpty(pendingPtoRequests) && (
						<div style={{ padding: 20, fontSize: 18, color: '#666', paddingBottom: 10 }}>
							There are not any scheduled PTO requests that are pending.
						</div>
					)}
					{!_.isEmpty(pendingPtoRequests) && (
						<EnhancedTable
							rows={pendingPtoRequests}
							columns={columns}
							isDense={true}
							defaultOrder={'desc'}
							defaultOrderBy={'dateCreatedFormatted'}
							refreshId={this.state.refreshId}
						/>
					)}
				</Paper>

				<FilterHeader label={'Completed PTO Request'} canMakeUpdates={true} />
				<Paper className={classes.globalMainPaper}>
					{_.isEmpty(completedPtoRequests) && (
						<div style={{ padding: 20, fontSize: 18, color: '#666', paddingBottom: 10 }}>
							There are not any schedule PTO requests that are completed.
						</div>
					)}
					{!_.isEmpty(completedPtoRequests) && (
						<EnhancedTable
							rows={completedPtoRequests}
							columns={columns}
							isDense={true}
							defaultOrder={'desc'}
							defaultOrderBy={'dateCreatedFormatted'}
							refreshId={this.state.refreshId}
						/>
					)}
				</Paper>
			</Fragment>
		);
	}
}

RequiredPtoDashboard.propTypes = {
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	searchRequiredPtoRequests: PropTypes.func.isRequired,
	allRequiredPtoRequests: PropTypes.array,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	RequiredPtoRequestContainer,
])(RequiredPtoDashboard);
